import _mergeJSXProps4 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps3 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isEqual, isFunction } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { normalizeFile, handleFileList, getFile } from './utils';
import Locale from '../locale/lang/default';
import Props from './uploader/props';
import Uploader from './uploader';
import List from './list';
export default {
  name: buildComponentName('Upload'),
  $_veeValidate: {
    value: function value() {
      return this.innerFileList;
    }
  },
  model: {
    prop: 'fileList'
  },
  props: _objectSpread({}, Props, {
    prefixCls: {
      type: String,
      default: 'ux-upload'
    },
    type: {
      type: String,
      default: 'select',
      validator: function validator(val) {
        return ['select', 'drag'].indexOf(val) > -1;
      }
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showUploadList: {
      type: [Boolean, Object],
      default: true
    },
    listType: {
      type: String,
      default: 'text',
      validator: function validator(val) {
        return ['text', 'picture', 'picture-card'].indexOf(val) > -1;
      }
    },
    beforeRemove: {
      type: Function,
      default: null
    },
    locale: {
      type: Object,
      default: function _default() {
        return Locale.Upload;
      }
    },
    control: {
      type: Boolean,
      default: false
    },
    onPreview: {
      type: Function,
      default: null
    }
  }),
  data: function data() {
    return {
      innerFileList: [],
      dragState: 'drop',
      globalDragEvents: null
    };
  },
  computed: {
    uploadBtnClasses: function uploadBtnClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          listType = this.listType,
          disabled = this.disabled;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-select"), true), _defineProperty(_ref, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_ref, "".concat(prefixCls, "-disabled"), disabled), _ref;
    },
    dragClasses: function dragClasses() {
      var _ref2;

      var prefixCls = this.prefixCls,
          dragState = this.dragState,
          innerFileList = this.innerFileList,
          disabled = this.disabled;
      var dragCls = "".concat(prefixCls, "-drag");
      return _ref2 = {}, _defineProperty(_ref2, prefixCls, true), _defineProperty(_ref2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_ref2, dragCls, true), _defineProperty(_ref2, "".concat(dragCls, "-hover"), dragState === 'dragover'), _defineProperty(_ref2, "".concat(dragCls, "-uploading"), innerFileList.some(function (file) {
        return file.status === 'uploading';
      })), _ref2;
    }
  },
  watch: {
    fileList: function fileList(nVal) {
      this.setInnerFileList(handleFileList(nVal), true);
    }
  },
  created: function created() {
    var fileList = this.fileList,
        setInnerFileList = this.setInnerFileList;
    setInnerFileList(handleFileList(fileList), true);
  },
  methods: {
    getWaitUploadOriginFiles: function getWaitUploadOriginFiles() {
      var innerFileList = this.innerFileList;
      return innerFileList.filter(function (file) {
        return file.status === 'ready';
      }).map(function (file) {
        return file.originFile;
      });
    },
    uploadFile: function uploadFile(file) {
      var uploaderRef = this.$refs.uploaderRef,
          innerFileList = this.innerFileList,
          getWaitUploadOriginFiles = this.getWaitUploadOriginFiles;

      if (uploaderRef) {
        var waitUploadOriginFiles = getWaitUploadOriginFiles();
        var originFile = file;

        if (typeof originFile === 'string') {
          var filterFiles = innerFileList.filter(function (v) {
            return v.uid === originFile;
          });
          originFile = filterFiles.length > 0 ? filterFiles[0].originFile : null;
        }

        var fileType = toString.call(originFile); // ajax 上传必须是 File,
        // iframe上传

        if (fileType === '[object File]') {
          uploaderRef.upload(file, waitUploadOriginFiles);
        }
      }
    },
    submit: function submit() {
      var uploadFile = this.uploadFile,
          getWaitUploadOriginFiles = this.getWaitUploadOriginFiles;
      var waitUploadOriginFiles = getWaitUploadOriginFiles();
      waitUploadOriginFiles.forEach(function (file) {
        uploadFile(file);
      });
    },
    abort: function abort(file) {
      var uploaderRef = this.$refs.uploaderRef,
          chunk = this.chunk;
      var chunkId = file.chunkId,
          uid = file.uid;

      if (uploaderRef && (chunk && chunkId || !chunk && uid)) {
        uploaderRef.abort(chunk ? chunkId : uid);
      }
    },
    setInnerFileList: function setInnerFileList() {
      var fileList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var pass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var innerFileList = this.innerFileList,
          control = this.control;

      if (!control || pass) {
        if (!isEqual(innerFileList, fileList)) {
          this.innerFileList = fileList;
        }
      }
    },
    onChange: function onChange() {
      var changed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!this.control) {
        this.$emit('input', changed.fileList);
      }

      this.$emit('change', changed);
    },
    onReady: function onReady(file) {
      var innerFileList = this.innerFileList,
          onChange = this.onChange,
          setInnerFileList = this.setInnerFileList;
      var nFile = normalizeFile(file);
      nFile.status = 'ready';

      if (URL.createObjectURL) {
        nFile.thumbUrl = URL.createObjectURL(file);
      }

      var nFileList = [].concat(_toConsumableArray(innerFileList), [nFile]);
      setInnerFileList(nFileList);
      onChange({
        file: _objectSpread({}, nFile),
        fileList: nFileList
      });
    },
    onStart: function onStart(file) {
      var innerFileList = this.innerFileList,
          onChange = this.onChange;
      var nFile = getFile(file, innerFileList);

      if (nFile) {
        nFile.status = 'uploading';
        onChange({
          file: _objectSpread({}, nFile),
          fileList: _toConsumableArray(innerFileList)
        });
      }
    },
    onSuccess: function onSuccess(response, file) {
      var innerFileList = this.innerFileList,
          onChange = this.onChange;
      var nFile = getFile(file, innerFileList);

      if (nFile) {
        nFile.status = 'success';
        nFile.response = response;

        var changedFile = _objectSpread({}, nFile);

        var fileList = _toConsumableArray(innerFileList);

        onChange({
          file: changedFile,
          fileList: fileList
        });
        this.$emit('success', response, changedFile, fileList);
      }
    },
    onError: function onError(error, response, file) {
      var innerFileList = this.innerFileList,
          onChange = this.onChange;
      var nFile = getFile(file, innerFileList);

      if (nFile) {
        nFile.status = 'error';
        nFile.error = error;
        nFile.response = response;

        var changedFile = _objectSpread({}, nFile);

        var fileList = _toConsumableArray(innerFileList);

        onChange({
          file: changedFile,
          fileList: fileList
        });
        this.$emit('error', error, response, changedFile, fileList);
      }
    },
    onProgress: function onProgress(e, file) {
      var innerFileList = this.innerFileList,
          onChange = this.onChange;
      var nFile = getFile(file, innerFileList);

      if (nFile) {
        nFile.percent = e.percent;

        var changedFile = _objectSpread({}, nFile);

        var fileList = _toConsumableArray(innerFileList);

        onChange({
          event: e,
          file: changedFile,
          fileList: fileList
        });
        this.$emit('progress', e, changedFile, fileList);
      }
    },
    onRemove: function onRemove(file) {
      var _this = this;

      var uploaderRef = this.$refs.uploaderRef,
          beforeRemove = this.beforeRemove,
          innerFileList = this.innerFileList,
          onChange = this.onChange,
          setInnerFileList = this.setInnerFileList;

      if (uploaderRef) {
        Promise.resolve(isFunction(beforeRemove) ? beforeRemove(file) : true).then(function (ret) {
          if (ret === false) {
            return;
          }

          var nFile = file;
          var uid = nFile.uid,
              thumbUrl = nFile.thumbUrl;

          if (URL.revokeObjectURL && thumbUrl) {
            URL.revokeObjectURL(thumbUrl);
          }

          uploaderRef.abort(nFile);
          nFile.status = 'removed';
          var fileList = innerFileList.filter(function (v) {
            return v.uid !== uid;
          });
          setInnerFileList(fileList);

          var changedFile = _objectSpread({}, nFile);

          onChange({
            file: changedFile,
            fileList: fileList
          });

          _this.$emit('remove', changedFile, fileList);
        });
      }
    },
    onDrop: function onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.dragState = e.type;
      e.dataTransfer.dropEffect = 'move';
    },
    onChunkSend: function onChunkSend(chunk) {
      var innerFileList = this.innerFileList;
      var file = chunk.file,
          chunkId = chunk.chunkId;
      var nFile = getFile(file, innerFileList);

      if (nFile) {
        nFile.chunkId = chunkId;
      }

      this.$emit('chunk-send', chunk);
    },
    onChunkSuccess: function onChunkSuccess(response, chunk) {
      this.$emit('chunk-success', response, chunk);
    },
    onChunkError: function onChunkError(err, response, chunk) {
      this.$emit('chunk-error', err, response, chunk);
    },
    onPause: function onPause(file) {
      var uploaderRef = this.$refs.uploaderRef,
          innerFileList = this.innerFileList,
          onChange = this.onChange,
          chunk = this.chunk;
      var nFile = file;

      if (nFile) {
        var uid = nFile.uid,
            chunkId = nFile.chunkId;

        if (uploaderRef && (chunk && chunkId || !chunk && uid)) {
          uploaderRef.abort(chunk ? chunkId : uid);

          var changedFile = _objectSpread({}, nFile);

          var fileList = _toConsumableArray(innerFileList);

          nFile.status = 'pause';
          onChange({
            file: changedFile,
            fileList: fileList
          });
          this.$emit('pause', changedFile, fileList);
        }
      }
    },
    onRun: function onRun(file) {
      var uploaderRef = this.$refs.uploaderRef,
          innerFileList = this.innerFileList,
          chunk = this.chunk,
          data = this.data,
          uploadedBytes = this.uploadedBytes,
          uploadFile = this.uploadFile,
          onChange = this.onChange;
      var nFile = file;

      if (uploaderRef && nFile) {
        var originFile = nFile.originFile,
            fileSize = nFile.size;
        nFile.status = 'uploading';

        if (chunk) {
          Promise.resolve(isFunction(data) ? data(originFile) : data).then(function (formData) {
            var ubytesRet = isFunction(uploadedBytes) ? uploadedBytes(originFile, formData) : uploadedBytes;
            Promise.resolve(ubytesRet).then(function (ubytes) {
              var ub = Number(ubytes) || 0;

              if (ub >= fileSize) {
                nFile.status = 'error';
                nFile.error = new Error('uplodedbytes > file.size');
                return;
              } // eslint-disable-next-line


              nFile.percent = ub / fileSize * 100;
              uploadFile(originFile);
            });
          });
        } else {
          uploadFile(originFile);
        }

        onChange({
          file: _objectSpread({}, nFile),
          fileList: _toConsumableArray(innerFileList)
        });
      }
    },
    renderUploadList: function renderUploadList() {
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          listType = this.listType,
          innerFileList = this.innerFileList,
          showUploadList = this.showUploadList,
          locale = this.locale,
          autoUpload = this.autoUpload,
          chunk = this.chunk,
          uploadedBytes = this.uploadedBytes,
          onRemove = this.onRemove,
          onPause = this.onPause,
          onRun = this.onRun,
          onPreview = this.onPreview;

      if (showUploadList === false) {
        return null;
      }

      var _ref3 = typeof showUploadList === 'boolean' ? {} : showUploadList || {},
          showPreviewIcon = _ref3.showPreviewIcon,
          showRemoveIcon = _ref3.showRemoveIcon;

      var props = {
        prefixCls: prefixCls,
        listType: listType,
        showPreviewIcon: showPreviewIcon,
        showRemoveIcon: showRemoveIcon,
        list: innerFileList,
        locale: locale,
        autoUpload: autoUpload,
        chunk: chunk,
        uploadedBytes: uploadedBytes,
        onPreview: onPreview
      };
      var on = {
        remove: onRemove,
        pause: onPause,
        run: onRun
      };
      return h(List, {
        "props": _objectSpread({}, props),
        "on": _objectSpread({}, on)
      });
    },
    onBeforeReady: function onBeforeReady(selectedFiles) {
      var beforeReady = this.beforeReady,
          innerFileList = this.innerFileList;

      if (!isFunction(beforeReady)) {
        return true;
      }

      var before = beforeReady(selectedFiles, innerFileList);

      if (before === false) {
        return false;
      }

      if (before && isFunction(before.then)) {
        return before;
      }

      return true;
    },
    onBeforeUpload: function onBeforeUpload(file, files) {
      var innerFileList = this.innerFileList,
          beforeUpload = this.beforeUpload;

      if (!isFunction(beforeUpload)) {
        return true;
      }

      var before = beforeUpload(file, files, innerFileList);

      if (before === false) {
        return false;
      }

      if (before && isFunction(before.then)) {
        return before;
      }

      return true;
    },
    renderUploadButton: function renderUploadButton() {
      var h = this.$createElement;
      var $props = this.$props,
          slotDefault = this.$slots.default,
          prefixCls = this.prefixCls,
          type = this.type,
          uploadBtnClasses = this.uploadBtnClasses,
          dragClasses = this.dragClasses,
          onBeforeUpload = this.onBeforeUpload,
          onBeforeReady = this.onBeforeReady,
          onReady = this.onReady,
          onSuccess = this.onSuccess,
          onError = this.onError,
          onProgress = this.onProgress,
          onStart = this.onStart,
          onDrop = this.onDrop,
          onChunkSuccess = this.onChunkSuccess,
          onChunkSend = this.onChunkSend,
          onChunkError = this.onChunkError;

      var props = _objectSpread({}, $props, {
        beforeUpload: onBeforeUpload,
        beforeReady: onBeforeReady
      });

      var dragEvent = {
        drop: onDrop,
        dragover: onDrop,
        dragleave: onDrop
      };
      var on = {
        ready: onReady,
        start: onStart,
        success: onSuccess,
        error: onError,
        progress: onProgress,
        'chunk-send': onChunkSend,
        'chunk-success': onChunkSuccess,
        'chunk-error': onChunkError
      };
      return type === 'drag' ? h("div", _mergeJSXProps2([{}, {
        class: dragClasses,
        on: dragEvent
      }]), [h(Uploader, _mergeJSXProps([{}, {
        class: "".concat(prefixCls, "-btn"),
        props: props,
        on: on,
        ref: 'uploaderRef'
      }]), [h("div", {
        "class": "".concat(prefixCls, "-drag-container")
      }, [slotDefault])])]) : h("span", _mergeJSXProps4([{
        "directives": [{
          name: "show",
          value: !!slotDefault
        }]
      }, {
        class: uploadBtnClasses
      }]), [h(Uploader, _mergeJSXProps3([{}, {
        props: props,
        on: on,
        ref: 'uploaderRef'
      }]), [slotDefault])]);
    },
    renderUpload: function renderUpload() {
      var h = this.$createElement;
      var slotTip = this.$slots.tip,
          prefixCls = this.prefixCls,
          listType = this.listType,
          renderUploadButton = this.renderUploadButton,
          renderUploadList = this.renderUploadList;
      var uploadButton = renderUploadButton();
      var uploadList = renderUploadList();
      var tipNode = h("div", {
        "class": "".concat(prefixCls, "-tip")
      }, [slotTip]);
      return h("span", [listType === 'picture-card' ? [uploadList, uploadButton, tipNode] : [uploadButton, tipNode, uploadList]]);
    }
  },
  render: function render() {
    var renderUpload = this.renderUpload;
    return renderUpload();
  }
};